import { PaisResidencia } from 'src/tipos'

export const PAISES = ['Brasil', 'Outro']

export const SELECT_PAISES = PAISES.map(pais => ({
  id: PaisResidencia[pais],
  texto: pais
}))
